<template>
  <v-col
    cols="12"
    md="12"
    contain
    class="card-head d-flex justify-space-between"
  >
    <v-icon
      v-if="this.lenderView"
      class="ml-4 pr-lg-8"
      small
      color="white"
      style="font-size: 20px"
      @click="$router.push('/dashboard/?s=2')"
      >fas fa-arrow-left</v-icon
    >

    <v-icon
      v-if="this.borrowerView"
      class="ml-4 pr-lg-8"
      small
      color="white"
      style="font-size: 20px"
      @click="$router.push('/dashboard/?s=3')"
      >fas fa-arrow-left</v-icon
    >

    <p
      class="white--text text-caption text-md-subtitle-1 text-lg-h5 ml-lg-6 mt-4"
      v-if="this.lenderView == true"
    >
      Booking Request
    </p>

    <p
      class="white--text text-caption text-md-subtitle-1 text-lg-h5 ml-lg-6 mt-4"
      v-else-if="this.borrowerView == true"
    >
      Booking Request
    </p>

    <v-menu class="list" offset-y transition="slide-y-transition" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="[attrs]"
          v-on="on"
          rounded
          class="hidden mr-4 mt-4 app--text font-weight-medium"
          color="grey lighten-3"
          small
          z-index="12"
        >
          <u class="hidden-sm-and-down">Manage</u>
          <!-- gear icon -->
          <v-icon small class="mt-1 hidden-md-and-up"> fas fa-cog</v-icon>
          <v-icon x-small class="mt-1 ml-2"> fas fa-chevron-down</v-icon>
        </v-btn>
      </template>

      <v-card class="list">
        <v-list class="list" dense>
          <v-list-item-group>
            <v-list-item
              @click="
                (supportType = 'General Enquiry'),
                  (userType = 'borrower'),
                  $router.push({
                    name: 'support',
                    params: {
                      booking,
                      supportType,
                      userType,
                    },
                  })
              "
            >
              <p class="mb-n2 mt-n2 caption">
                <v-icon x-small class="mr-2">fas fa-question</v-icon>General
                Enquiry
              </p>
            </v-list-item>

            <v-divider></v-divider>
            <v-list-item
              @click="
                (supportType = 'Log an Issue'),
                  (userType = 'borrower'),
                  $router.push({
                    name: 'support',
                    params: {
                      booking,
                      supportType,
                      userType,
                    },
                  })
              "
            >
              <p class="mb-n2 mt-n2 caption">
                <v-icon x-small class="mr-2">fas fa-warning</v-icon>Log an Issue
              </p>
            </v-list-item>
            <!-- <v-divider></v-divider>
                  <v-list-item
                    @click="
                      (supportType = 'Log an Issue'),
                        (userType = 'borrower'),
                        $router.push({
                          name: 'support',
                          params: {
                            booking,
                            supportType,
                            userType,
                          },
                        })
                    "
                  >
                    <p class="mb-n2 mt-n2 caption">
                      <v-icon x-small class="mr-2">fas fa-remove</v-icon>
                      Cancel Booking
                    </p>
                  </v-list-item> -->
          </v-list-item-group>
        </v-list>
      </v-card>
    </v-menu>
  </v-col>
</template>

<script>
export default {
  name: 'BookingHeader',

  data() {
    return {};
  },

  props: {
    booking: {
      type: Object,
      default: () => {},
    },
    lenderView: {
      type: Boolean,
      default: false,
    },
    borrowerView: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    console.log('bookingHeader', this.lenderView, this.borrowerView);
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
.card-head {
  background-color: #b22af0;
  width: 100%;
  padding: 14px;
}
</style>
